import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Constants } from '../../../../shared/utils/constants';
import { BonusService } from '../../bonus.service';
import { IBBonusResponse } from '../../../../models/bonus.interface';
import * as _ from 'underscore';
import { NgForm } from '@angular/forms';
import { AppService } from '../../../../app.service';

@Component({
  selector: 'app-ib-bonus',
  templateUrl: './ib-bonus.component.html',
  styleUrls: ['./ib-bonus.component.scss']
})
export class IbBonusComponent implements OnInit {
  @ViewChild('form') form: NgForm;
  @Input() permission;
  mode = 0;
  rateOrigin = 1;
  data: IBBonusResponse;
  viewBonus: {conditions: {rate: number; threshold: any}[]; up_limit_usd: number} = { conditions: [], up_limit_usd: 0 };
  dfws = _.range(0, 101);
  subscriptions: any = {};

  constructor(
    private readonly bonusService: BonusService,
    private readonly appService: AppService
  ) { }

  ngOnInit(): void {
    this.getRate();
    this.getBonusSetting();
  }

  getRate(baseSymbol = 'usdjpy'): void {
    const option = {
      symbol: baseSymbol,
    };
    this.bonusService.getRateBySymbol(option).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.rateOrigin = res.data.rate;
      }
    });
  }

  onConvertDate(time, isTime = false): any {
    return isTime ? new Date(time).getTime() : new Date(time);
  }

  /*getDefaultSetting(): void {
    this.bonusService.getIBDefaultSettings().subscribe(r => {
      console.log(`res: `, r.data);
      this.defaultSetting = r.data;
      this.bonusTimeoutSelected =  (this.defaultSetting.deposit.distance_from_withdraw || 0) / 86400000;
      this.defaultSetting.deposit.start_time = this.onConvertDate(this.defaultSetting.deposit.start_time);
      this.defaultSetting.deposit.end_time = this.onConvertDate(this.defaultSetting.deposit.end_time);
      this.defaultSetting.deposit.up_limit_start_time = this.onConvertDate(this.defaultSetting.deposit.up_limit_start_time);
      this.defaultSetting.open_account.start_time = this.onConvertDate(this.defaultSetting.open_account.start_time);
      this.defaultSetting.open_account.end_time = this.onConvertDate(this.defaultSetting.open_account.end_time);
      this.defaultSetting.deposit.up_limit = this.defaultSetting.deposit.up_limit ?? 0;
      this.defaultSetting.deposit.conditions.forEach(e => {
        e.rateByPercent = e.rate * 100;
      });
      this.defaultSetting.deposit.up_limit_usd = this.defaultSetting.deposit.up_limit / this.rateOrigin;
    })
  }*/

  onSubmitSetting() {
    if (this.data.deposit.mode === 1){
      if(this.data.deposit.comment.trim() == ''){
        this.appService.showError('Deposit Comment should not be empty');
        return;
      }
      if (this.data.deposit.comment.match(/^[0-9a-zA-Z]+$/) == null) {
        this.appService.showError('Deposit Comment should not contain special characters and space');
        return;
      }
      if(this.data.deposit.up_limit_start_time === '' || this.data.deposit.up_limit_start_time === null){
        this.appService.showError('Upper Limit Start Time should not be empty');
        return;
      }
    }
    if (this.data.open_account.mode === 1){
      if(this.data.open_account.comment.trim() == ''){
        this.appService.showError('Open Account Comment should not be empty');
        return;
      }
      if (this.data.open_account.comment.match(/^[0-9a-zA-Z]+$/) == null) {
        this.appService.showError('Open Account Comment should not contain special characters and space');
        return;
      }
    }
    if (
      this.data.deposit.start_time > this.data.deposit.end_time
    ) {
      this.appService.showError('Please enter param setting bonus');
      return;
    }
    // check valid param
    let isValidCondition = true;
    this.data.deposit.conditions.some((ch) => {
      if (ch.threshold) {
        if (!ch.rate || ch.rate < 0) {
          isValidCondition = false;
          return true;
        }
      }
      if (ch.rate) {
        if (!ch.threshold || ch.threshold < 0) {
          isValidCondition = false;
          return true;
        }
      }
    });
    if (!isValidCondition) {
      this.appService.showError('Please enter param setting conditions');
      return;
    }
    const newData = JSON.parse(JSON.stringify(this.data));
    newData.deposit.start_time = this.onConvertDate(
      this.data.deposit.start_time,
      true
    );
    newData.deposit.end_time = this.onConvertDate(
      this.data.deposit.end_time,
      true
    );
    newData.deposit.up_limit_start_time = this.onConvertDate(
      this.data.deposit.up_limit_start_time,
      true
    );
    newData.open_account.start_time = this.onConvertDate(
      this.data.open_account.start_time,
      true
    );
    newData.open_account.end_time = this.onConvertDate(
      this.data.open_account.end_time,
      true
    );
    newData.deposit.conditions = newData.deposit.conditions
    .filter((f) => f.rate > 0 && f.threshold >= 0)
    .map((v) => {
      v.rate = v.rate / 100;
      return v;
    });
    newData.deposit.distance_from_withdraw = 86400000 * newData.deposit.dfw;
    delete(newData.deposit.dfw);
    this.appService
    .confirm({
      title: `Are you sure that you want to apply?`,
      ok: 'Yes',
      cancel: 'No',
    })
    .subscribe((v: any) => {
      if (v.result) {
        this.subscriptions.updateSettingBonus =  this.bonusService.updateIbSettings(newData).subscribe((res) => {
          if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
            this.appService.showSuccess('Bonus Setting success.');
          } else {
            this.appService.showError('Bonus Setting fail.');
          }
        });
      }
    });
  }

  getBonusSetting(): void {
    this.subscriptions.getSettingBonus = this.bonusService.getSettingBonus('permanent_bonus_ib').subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        // @ts-ignore
        this.data = res.data;
        this.data.deposit.start_time = this.onConvertDate(
          res.data.deposit.start_time
        );
        this.data.deposit.end_time = this.onConvertDate(
          res.data.deposit.end_time
        );
        this.data.open_account.start_time = this.onConvertDate(
          res.data.open_account.start_time
        );
        this.data.open_account.end_time = this.onConvertDate(
          res.data.open_account.end_time
        );
        this.data.deposit.up_limit_start_time = this.onConvertDate(this.data.deposit.up_limit_start_time);
        this.data.deposit.up_limit = this.data.deposit.up_limit ?? 0;
        this.data.deposit.dfw =
          (this.data.deposit.distance_from_withdraw || 0) / 86400000;
        const mixConditions = res.data.deposit['conditions'].map((v, i) => {
          this.onUpdateRateUJ('conditions', i);
          v.rate = v.rate * 100;
          return v;
        });
        // check condition default 4 record
        this.data.deposit.conditions =
          this.generateConditionRecord(mixConditions);
        this.onUpdateRateUJ('up_limit_usd', 0);
        if (this.data.deposit.comment === undefined){
          this.data.deposit.comment = '';
        }
        if (this.data.open_account.comment === undefined){
          this.data.open_account.comment = '';
        }
      }
    });
  }
  onUpdateRateUJ(key, index): void {
    if (key === 'conditions') {
      const baseValue = this.data.deposit?.conditions[index].threshold;
      // @ts-ignore
      this.viewBonus.conditions.push({threshold: (baseValue / this.rateOrigin).toFixed(2)})
      // this.viewBonus.conditions[index].threshold = (baseValue / this.rateOrigin).toFixed(2);
    } else {
      this.viewBonus[key] = (
        (this.data.deposit.up_limit || 0) / this.rateOrigin
      ).toFixed(2);
    }
  }

  generateConditionRecord(conditions): any {
    const totalRecord = conditions.length;
    const records = conditions;
    for (let r = totalRecord; r < 4; r++) {
      const item = {
        threshold: null,
        rate: null,
      };
      records.push(item);
    }
    return records;
  }
}
